import { memo } from 'react'
import { AuthorityListPanel } from '../authorityListPanel/authorityListPanel'
import { RoleType } from '@crew/enums/domain'

export const AuthoritySystemSettingPanel = memo(() => {
  return <AuthorityListPanel roleType={RoleType.System} newRole={null} />
})
